"use client";

import { usePathname, useRouter } from "next/navigation";
import { useTranslations } from "next-intl";

import { cn } from "@/lib/cn";

/**
 * Top switch Fan Zone ↔ Niaga & Layanan (design.md §1).
 * Highlight bergeser secara fisik antara dua pilihan.
 */
export type Zone = "fan" | "niaga";

export function ZoneSwitcher() {
  const t = useTranslations("ZoneSwitcher");
  const router = useRouter();
  const pathname = usePathname();
  const zone: Zone = pathname.startsWith("/niaga") ? "niaga" : "fan";

  function select(next: Zone) {
    if (next === zone) return;
    router.push(next === "niaga" ? "/niaga" : "/beranda");
  }

  return (
    <div
      role="tablist"
      aria-label={t("modeAplikasi")}
      className="relative flex rounded-full border border-outline-variant/20 bg-surface-container-lowest p-1"
    >
      <span
        aria-hidden
        className={cn(
          "kinetic-gradient absolute inset-y-1 w-[calc(50%-0.25rem)] rounded-full transition-transform duration-300",
          zone === "niaga" && "translate-x-full",
        )}
      />
      {(
        [
          ["fan", t("fanZone")],
          ["niaga", t("niagaLayanan")],
        ] as const
      ).map(([value, label]) => (
        <button
          key={value}
          role="tab"
          aria-selected={zone === value}
          onClick={() => select(value)}
          className={cn(
            "relative z-10 flex-1 rounded-full py-2 text-body-sm font-semibold transition-colors",
            zone === value ? "text-white" : "text-on-surface-variant",
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
